import { render, staticRenderFns } from "./ChartEquipo.vue?vue&type=template&id=08e72067&scoped=true&"
import script from "./ChartEquipo.vue?vue&type=script&lang=js&"
export * from "./ChartEquipo.vue?vue&type=script&lang=js&"
import style0 from "./ChartEquipo.vue?vue&type=style&index=0&id=08e72067&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e72067",
  null
  
)

export default component.exports